import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { useCollapse } from './context';
import { ReactComponent as ChevronIcon } from 'images/icons/chevron-left.svg';

export function CollapseChevron({ className = '' }) {
  const { isOpen } = useCollapse();

  return (
    <ChevronIcon data-open={isOpen} className={cn(styles.chevron, className)} />
  );
}
